module.exports = __webpack_public_path__ + "img/com-banner-catalogue.8e8c7944.svg";